<div class="baner-config-created-container">
  <h3>
    {{ ('view_translations.deep_link_created_info' | translate) + ' "' + selectedConfigurationName + '" ' + ('view_translations.deep_link_has_been_added' |
    translate) }}
  </h3>
  <h4>{{ 'view_translations.deep_link_copy_generated_link' | translate }}</h4>
</div>
